import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Terminal } from '../models/entities/terminal';
import { VTerminal } from '../models/entities/v-terminal';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class TerminalService {

  constructor(private httpClient: HttpClient) { }

  getList(): Observable<ListResponseModel<VTerminal>> {
    return this.httpClient.get<ListResponseModel<VTerminal>>(ApiUrl.url + "Terminal/getList");
  }

  getListByPortalId(portalId: number, status: boolean): Observable<ListResponseModel<VTerminal>> {
    return this.httpClient.get<ListResponseModel<VTerminal>>(ApiUrl.url + "Terminal/getListByPortalId?portalId=" + portalId + "&status=" + status);
  }

  getListByStatus(status: boolean): Observable<ListResponseModel<VTerminal>> {
    return this.httpClient.get<ListResponseModel<VTerminal>>(ApiUrl.url + "Terminal/getListByStatus?status=" + status);
  }

  getCustomerTerminals(customerTerminalMainId: number): Observable<ListResponseModel<VTerminal>> {
    return this.httpClient.get<ListResponseModel<VTerminal>>(ApiUrl.url + "Terminal/getCustomerTerminals?customerTerminalMainId=" + customerTerminalMainId);
  }

  getById(id: number): Observable<ObjectResponseModel<Terminal>> {
    return this.httpClient.get<ObjectResponseModel<Terminal>>(ApiUrl.url + "Terminal/getById?Id=" + id);
  }

  getByTerminalId(terminalId: string): Observable<ObjectResponseModel<VTerminal>> {
    return this.httpClient.get<ObjectResponseModel<VTerminal>>(ApiUrl.url + "Terminal/getByTerminalId?terminalId=" + terminalId);
  }

  getByImei(imei: string): Observable<ObjectResponseModel<Terminal>> {
    return this.httpClient.get<ObjectResponseModel<Terminal>>(ApiUrl.url + "Terminal/getByImei?imei=" + imei);
  }

  add(terminal: Terminal) {
    return this.httpClient.post<ObjectResponseModel<Terminal>>(ApiUrl.url + "Terminal/add", terminal);
  }

  importTerminal(terminals: VTerminal[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/importTerminal", terminals);
  }

  update(terminal: Terminal) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/update", terminal);
  }

  statusUpdate(terminal: Terminal) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/statusUpdate", terminal);
  }

  statusUpdateRangeTrue(terminals: VTerminal[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/statusUpdateRangeTrue", terminals);
  }

  statusUpdateRangeFalse(terminals: VTerminal[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/statusUpdateRangeFalse", terminals);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/delete?Id=" + id, "");
  }

  deleteRange(terminals: VTerminal[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Terminal/deleteRange", terminals);
  }

}
